autoslash.createNamespace("autoslash.ajax");
autoslash.register(autoslash.ajax);

autoslash.ajax.initialize = function() {
    "use strict";
    autoslash.ajax.spinner = new Spinner();
};

autoslash.ajax.block = function (element) {
    "use strict";
    autoslash.ajax.spinner.spin();
    var options =
    {
        message: autoslash.ajax.spinner.el,
        css: {
            border: "none"
        },
        overlayCSS: {
            opacity: 0.2
        },
        baseZ: 2500
    };
    if (element) {
        element.block(options);
    } else {
        $.blockUI(options);
    }
};

autoslash.ajax.unblock = function (element) {
    "use strict";
    if (element) {
        element.unblock();
    } else {
        $.unblockUI();
    }
    autoslash.ajax.spinner.stop();
};

autoslash.ajax.showErrors = function(form, jsonErrors){
    "use strict";
    var keyedErrors = {}, allErrors = {};

    for (var j = 0; j < jsonErrors.length; j++) {
        var key = jsonErrors[j].key;
        if (key) {
            //Only keyed errors can be used with jQuery validation
            keyedErrors[key] = jsonErrors[j].message;
        }
        allErrors[j] = jsonErrors[j].message;
    }

    //Notify jQuery validation of the keyed errors
    form.validate().showErrors(keyedErrors);

    //Add the errors to validation summary
    var container = form.find("[data-valmsg-summary=true]"),
        list = container.find("ul");

    if (list && list.length) {
        list.empty();
        container
            .addClass("validation-summary-errors")
            .removeClass("validation-summary-valid");

        $.each(allErrors, function (k, m) {
            $("<li />").html(m).appendTo(list);
        });
    }
}

autoslash.ajax.hideErrors = function (form) {
    "use strict";
    var container = form.find("[data-valmsg-summary=true]");
    container
        .removeClass("validation-summary-errors")
        .addClass("validation-summary-valid");
}